export const getDropdownFilterTank = () => {
    return {
        i18n: "installationoverview.tanks",
        i18nFallback: "Tank",
        label: "Tank",
        id: "tank",
        options: [
            {
                type: "check",
                variable: "type",
                options: [
                    {
                        id: "Fuel-1",
                        i18n: "installationoverview.tank_type.fuel",
                        label: "Fuel",
                        variable: "Fuel",
                        value: false
                    },
                    {
                        id: "Oil-2",
                        i18n: "installationoverview.tank_type.oil",
                        label: "Oil",
                        variable: "Oil",
                        value: false
                    },
                    {
                        id: "Sewage-3",
                        i18n: "installationoverview.tank_type.sewage",
                        label: "Sewage",
                        variable: "Sewage",
                        value: false
                    },
                    {
                        id: "Water-4",
                        i18n: "installationoverview.tank_type.water",
                        label: "Water",
                        variable: "Water",
                        value: false
                    },
                    {
                        id: "Others",
                        i18n: "installationoverview.tank_type.others",
                        label: "Others",
                        variable: "Others",
                        value: false
                    }
                ]
            },
            {
                type: "minMax",
                i18n: "installationoverview.tank.level",
                label: "Level",
                variable: "level",
                min: "",
                max: "",
                measure: "percentage" // used with class ::before
            }
        ]
    };
};